// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/Inter/Inter-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/Inter/Inter-Semibold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/fonts/Inter/Inter-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/fonts/museo/MuseoSansRounded100.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/museo/MuseoSansRounded300.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/fonts/museo/MuseoSansRounded500.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/fonts/museo/MuseoSansRounded700.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../assets/fonts/museo/MuseoSansRounded900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../assets/fonts/museo/MuseoSansRounded1000.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Inter";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Inter";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
  font-weight: 600;
  font-style: normal;
  font-display: swap;
}
@font-face {
  font-family: "Inter";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
/* 100 - Thin */
@font-face {
  font-family: "Museo Sans Rounded";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
  font-weight: 100;
  font-style: normal;
  font-display: swap;
}
/* 300 - Light */
@font-face {
  font-family: "Museo Sans Rounded";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: 300;
  font-style: normal;
  font-display: swap;
}
/* 500 - Medium */
@font-face {
  font-family: "Museo Sans Rounded";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
  font-weight: 500;
  font-style: normal;
  font-display: swap;
}
/* 700 - Bold */
@font-face {
  font-family: "Museo Sans Rounded";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
  font-weight: 700;
  font-style: normal;
  font-display: swap;
}
/* 900 - Black */
@font-face {
  font-family: "Museo Sans Rounded";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
  font-weight: 900;
  font-style: normal;
  font-display: swap;
}
/* 1000 - Heavy / Ultra */
@font-face {
  font-family: "Museo Sans Rounded";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
  font-weight: 1000;
  font-style: normal;
  font-display: swap;
}
*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  overscroll-behavior: none;
}

body {
  font-family: "Inter", sans-serif;
  background: #ffffff;
  overflow-x: hidden;
}

app-deeplink {
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.deeplink {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.deeplink-mobile {
  width: 100%;
  height: 100vh;
  height: 100dvh;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-y: contain;
  position: relative;
  padding-top: env(safe-area-inset-top);
  padding-left: env(safe-area-inset-left);
  padding-right: env(safe-area-inset-right);
  padding-bottom: env(safe-area-inset-bottom);
}
.deeplink-mobile__hero {
  position: sticky;
  top: 0;
  flex-shrink: 0;
  z-index: 0;
  isolation: isolate;
  width: 100%;
  height: clamp(320px, 44vh, 372px);
  padding-top: env(safe-area-inset-top);
  overflow: hidden;
}
.deeplink-mobile__hero-background {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: center top;
  pointer-events: none;
  user-select: none;
}
.deeplink-mobile__hero-logo {
  position: absolute;
  left: 50%;
  bottom: clamp(56px, 8.8vh, 74px);
  transform: translateX(-50%);
  width: clamp(170px, 51vw, 200px);
  height: auto;
  display: block;
  z-index: 3;
  pointer-events: none;
  user-select: none;
}
.deeplink-mobile__hero-coin {
  position: absolute;
  top: 66px;
  right: 36px;
  width: 73px;
  height: 73px;
  display: block;
  z-index: 2;
  transform: rotate(-16deg);
  pointer-events: none;
  user-select: none;
}
.deeplink-mobile__badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: clamp(6px, 1.5vw, 8px) clamp(18px, 5vw, 24px);
  position: absolute;
  top: clamp(132px, 19.5vh, 164px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 3;
  background: #00C4BB;
  border-radius: 24px 32px 0 24px;
  font-family: "Museo Sans Rounded", sans-serif;
  font-size: clamp(20px, 5.8vw, 24px);
  line-height: 1.26;
  font-weight: 700;
  color: #ffffff;
}
.deeplink-mobile__card {
  position: relative;
  flex: 1;
  z-index: 2;
  width: 100%;
  margin-top: -32px;
  background: #ffffff;
  border-radius: 32px 32px 0 0;
  padding: 34px 16px 40px;
  box-sizing: border-box;
}
.deeplink-mobile__title {
  width: 100%;
  margin: 0;
  color: #151d28;
  font-size: 20px;
  line-height: 24px;
  font-weight: 800;
  white-space: normal;
}
.deeplink-mobile__subtitle {
  width: 100%;
  margin: 8px 0 0;
  color: #485974;
  font-size: 16px;
  line-height: 20px;
  font-weight: 400;
}
.deeplink-mobile__buttons {
  width: 100%;
  margin-top: 28px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.deeplink-mobile__button {
  width: 100%;
  aspect-ratio: 114/96;
  padding: 0;
  border: 1px solid #edf1f5;
  border-radius: 18px;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(16, 24, 40, 0.04), 0 8px 18px rgba(16, 24, 40, 0.08);
  transition: transform 0.15s ease, box-shadow 0.2s ease;
  overflow: hidden;
  appearance: none;
  -webkit-tap-highlight-color: transparent;
  -webkit-user-select: none;
  user-select: none;
}
.deeplink-mobile__button:active {
  transform: scale(0.95);
}
.deeplink-mobile__button-logo {
  display: block;
  width: 79%;
  height: auto;
  object-fit: contain;
  object-position: center;
  flex-shrink: 0;
  max-width: none;
}
.deeplink-mobile__secure {
  margin-top: 28px;
  display: flex;
  align-items: center;
  gap: 10px;
}
.deeplink-mobile__secure-icon {
  display: block;
  width: 16px;
  height: 20px;
  flex-shrink: 0;
  object-fit: contain;
}
.deeplink-mobile__secure-text {
  color: #485974;
  font-size: 14px;
  line-height: 1.3;
  font-weight: 500;
}

@media (max-width: 360px) {
  .deeplink-mobile__title {
    font-size: 22px;
  }
  .deeplink-mobile__button {
    height: 88px;
  }
  .deeplink-mobile__button-logo--toke, .deeplink-mobile__button-logo--popular, .deeplink-mobile__button-logo--qik {
    width: 72px;
  }
}
@media (max-width: 290px) {
  .deeplink-mobile__buttons {
    grid-template-columns: 1fr;
  }
}
.deeplink-desktop {
  width: 100%;
  min-height: 100vh;
  min-height: 100dvh;
  padding: 24px;
  background: #ffffff;
  box-sizing: border-box;
}
.deeplink-desktop__shell {
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
  min-height: calc(100vh - 48px);
  min-height: calc(100dvh - 48px);
  display: grid;
  grid-template-columns: minmax(0, 1.08fr) minmax(420px, 0.92fr);
  gap: 40px;
  position: relative;
}
.deeplink-desktop__banner {
  position: relative;
  min-height: max(100vh - 48px, 480px);
  min-height: max(100dvh - 48px, 480px);
  border-radius: 30px;
  background: #5649B3;
  isolation: isolate;
  overflow: hidden;
}
.deeplink-desktop__banner-background {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  object-position: 68% center;
  border-radius: inherit;
  z-index: 0;
  pointer-events: none;
  user-select: none;
}
.deeplink-desktop__banner-glow {
  position: absolute;
  width: 460px;
  height: 460px;
  left: -150px;
  bottom: -250px;
  border-radius: 999px;
  background: linear-gradient(215.81deg, #22e6da 59.63%, #1cbab2 64.38%);
  opacity: 0.5;
  filter: blur(100px);
  z-index: 1;
  pointer-events: none;
}
.deeplink-desktop__banner-line {
  position: absolute;
  border-radius: 999px;
  pointer-events: none;
  z-index: 2;
}
.deeplink-desktop__banner-line--top {
  width: 110%;
  height: 4%;
  left: calc(13% - 0.0968 * max(100vh - 48px, 480px));
  left: calc(13% - 0.0968 * max(100dvh - 48px, 480px));
  top: 12%;
  background: linear-gradient(87.14deg, #22e6da 4.36%, rgba(34, 230, 218, 0) 79.64%);
  filter: blur(2px);
  transform: rotate(134deg);
}
.deeplink-desktop__banner-line--middle {
  width: 80%;
  height: 2.5%;
  right: calc(-8% - 0.0495 * max(100vh - 48px, 480px));
  right: calc(-8% - 0.0495 * max(100dvh - 48px, 480px));
  top: 65%;
  background: linear-gradient(150deg, #22e6da 3.07%, rgba(86, 73, 179, 0) 28%);
  transform: rotate(-134deg);
}
.deeplink-desktop__banner-logo {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: min(65%, 602px);
  height: auto;
  z-index: 3;
  display: block;
  pointer-events: none;
  user-select: none;
}
.deeplink-desktop__banner-decal {
  position: absolute;
  display: block;
  pointer-events: none;
  user-select: none;
  z-index: 4;
}
.deeplink-desktop__banner-decal--bottom {
  position: absolute;
  left: calc((100% - 40px) * 0.54 - 55px);
  top: 73%;
  width: clamp(110px, 11.7vw, 169px);
  height: auto;
  z-index: 6;
  transform: rotate(-21.72deg);
  pointer-events: none;
  user-select: none;
}
.deeplink-desktop__floating-decal {
  position: absolute;
  right: 0;
  top: 2%;
  width: 160px;
  height: auto;
  z-index: 6;
  pointer-events: none;
  user-select: none;
}
.deeplink-desktop__content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px 40px 24px 24px;
  text-align: center;
}
.deeplink-desktop__title {
  margin: 0;
  color: #101828;
  font-size: 30px;
  line-height: 1.02;
  font-weight: 800;
  letter-spacing: -0.03em;
}
.deeplink-desktop__subtitle {
  margin: 12px 0 0;
  color: #101828;
  font-size: 18px;
  line-height: 1.3;
  font-weight: 700;
  max-width: 420px;
}
.deeplink-desktop__helper-text {
  margin: 6px 0 0;
  color: #485974;
  font-size: 16px;
  line-height: 1.35;
  font-weight: 400;
  max-width: 360px;
}
.deeplink-desktop__qr {
  margin: 28px 0 16px;
}
.deeplink-desktop__copy {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 24px;
  border: none;
  border-radius: 31px;
  background: transparent;
  color: #5649B3;
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  cursor: pointer;
  appearance: none;
  overflow: hidden;
  transition: background-color 180ms ease, color 180ms ease, transform 120ms ease, box-shadow 180ms ease;
  -webkit-user-select: none;
  user-select: none;
}
.deeplink-desktop__copy:hover {
  background: #dcd9f2;
}
.deeplink-desktop__copy:active {
  background: #bdaef9;
  transform: scale(0.985);
}
.deeplink-desktop__copy:focus-visible {
  outline: none;
  box-shadow: 0 0 0 2px rgba(111, 98, 194, 0.18);
}
.deeplink-desktop__copy--success {
  background: #ccf7f5;
  color: #00807a;
}
.deeplink-desktop__copy--success:hover {
  background: #ccf7f5;
}
.deeplink-desktop__copy--success:active {
  background: #b9f0ed;
  transform: scale(0.985);
}
.deeplink-desktop__copy--success .deeplink-desktop__copy-label {
  color: #00807a;
}
.deeplink-desktop__copy--success .deeplink-desktop__copy-icon {
  transform: scale(1.05);
}
.deeplink-desktop__copy-label {
  transition: color 180ms ease, opacity 180ms ease;
}
.deeplink-desktop__copy-icon {
  width: 24px;
  height: 24px;
  display: block;
  flex-shrink: 0;
  object-fit: contain;
  transition: transform 220ms ease, opacity 180ms ease;
}

@keyframes deeplink-copy-success {
  0% {
    transform: scale(0.96);
  }
  60% {
    transform: scale(1.02);
  }
  100% {
    transform: scale(1);
  }
}
@media (max-width: 1280px) {
  .deeplink-desktop__shell {
    gap: 24px;
  }
  .deeplink-desktop__banner-decal--bottom {
    left: calc((100% - 24px) * 0.54 - 55px);
  }
  .deeplink-desktop__floating-decal {
    width: 140px;
  }
  .deeplink-desktop__content {
    padding-right: 0;
  }
}
@media (max-width: 1023px) {
  .deeplink-desktop__banner {
    min-height: 420px;
  }
  .deeplink-desktop__content {
    padding: 24px 0 0;
  }
  .deeplink-desktop__floating-decal {
    display: none;
  }
  .deeplink-desktop__banner-decal--bottom {
    display: none;
  }
}
@media (max-width: 768px) {
  .deeplink-desktop__shell {
    grid-template-columns: 1fr;
  }
  .deeplink-desktop__banner {
    display: none;
  }
  .deeplink-desktop__content {
    padding: 24px;
  }
}
.deeplink-error {
  width: 100%;
  height: 100vh;
  height: 100dvh;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.deeplink-error__card {
  flex: 1;
  z-index: 2;
  width: 100%;
  margin-top: -32px;
  background: #ffffff;
  border-radius: 32px 32px 0 0;
  padding: 40px 24px 48px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
.deeplink-error__icon-wrap {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: #dcd9f2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.deeplink-error__icon {
  width: 28px;
  height: 28px;
  color: #5649B3;
}
.deeplink-error__title {
  margin: 20px 0 0;
  color: #151d28;
  font-family: "Museo Sans Rounded", sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.2;
}
.deeplink-error__body {
  margin: 10px 0 0;
  color: #485974;
  font-size: 16px;
  line-height: 1.55;
  font-weight: 400;
  max-width: 280px;
}

.deeplink-error--desktop {
  align-items: center;
  justify-content: center;
}
.deeplink-error--desktop .deeplink-error__card {
  flex: none;
  width: 100%;
  max-width: 440px;
  margin-top: 0;
  border-radius: 24px;
  padding: 56px 48px;
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.04), 0 16px 48px rgba(16, 24, 40, 0.08);
}`, "",{"version":3,"sources":["webpack://./src/styles/_variables.scss","webpack://./src/styles/deeplink.scss"],"names":[],"mappings":"AA+CA;EACI,oBAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AC9CJ;ADiDA;EACI,oBAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AC/CJ;ADkDA;EACI,oBAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AChDJ;ADmDA,eAAA;AACA;EACI,iCAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ACjDJ;ADoDA,gBAAA;AACA;EACI,iCAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;AClDJ;ADqDA,iBAAA;AACA;EACI,iCAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ACnDJ;ADsDA,eAAA;AACA;EACI,iCAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ACpDJ;ADuDA,gBAAA;AACA;EACI,iCAAA;EACA,+DAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;ACrDJ;ADwDA,yBAAA;AACA;EACI,iCAAA;EACA,+DAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;ACtDJ;AAlEA;;;EAGE,sBAAA;AAoEF;;AAjEA;;EAEE,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;EACA,yBAAA;AAoEF;;AAjEA;EACE,gCAAA;EACA,mBDUoB;ECTpB,kBAAA;AAoEF;;AAjEA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AAoEF;;AAjEA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;AAoEF;;AA9DA;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,mBDdoB;ECgBpB,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EAEA,iCAAA;EACA,8BAAA;EAEA,kBAAA;EACA,qCAAA;EACA,uCAAA;EACA,yCAAA;EACA,2CAAA;AA8DF;AA5DE;EACE,gBAAA;EACA,MAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,iCAAA;EACA,qCAAA;EACA,gBAAA;AA8DJ;AA3DE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,2BAAA;EACA,oBAAA;EACA,iBAAA;AA6DJ;AA1DE;EACE,kBAAA;EACA,SAAA;EACA,gCAAA;EACA,2BAAA;EACA,gCAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,oBAAA;EACA,iBAAA;AA4DJ;AAzDE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,UAAA;EACA,yBAAA;EACA,oBAAA;EACA,iBAAA;AA2DJ;AAxDE;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EAEA,sDAAA;EAGA,kBAAA;EACA,gCAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EAEA,mBD3HmB;EC4HnB,+BAAA;EAEA,6CAAA;EACA,mCAAA;EACA,iBAAA;EACA,gBAAA;EACA,cDtGkB;AC2JtB;AAlDE;EACE,kBAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,mBD/GkB;ECgHlB,4BAAA;EACA,uBAAA;EACA,sBAAA;AAoDJ;AAjDE;EACE,WAAA;EACA,SAAA;EACA,cDtHkB;ECuHlB,eDhHO;ECiHP,iBAAA;EACA,gBAAA;EACA,mBAAA;AAmDJ;AAhDE;EACE,WAAA;EACA,eAAA;EACA,cDpJc;ECqJd,eD5HO;EC6HP,iBAAA;EACA,gBAAA;AAkDJ;AA/CE;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,qCAAA;EACA,SAAA;AAiDJ;AA9CE;EACE,WAAA;EACA,oBAAA;EACA,UAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBDtJkB;ECuJlB,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+EACE;EAEF,sDACE;EAEF,gBAAA;EACA,gBAAA;EACA,wCAAA;EACA,yBAAA;EACA,iBAAA;AA4CJ;AA1CI;EACE,sBAAA;AA4CN;AAxCE;EACE,cAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AA0CJ;AAvCE;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAyCJ;AAtCE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;AAwCJ;AArCE;EACE,cDvNc;ECwNd,eDhMO;ECiMP,gBAAA;EACA,gBAAA;AAuCJ;;AAnCA;EAEI;IACE,eAAA;EAqCJ;EAlCE;IACE,YAAA;EAoCJ;EAjCE;IAGE,WAAA;EAiCJ;AACF;AA7BA;EAEI;IACE,0BAAA;EA8BJ;AACF;AAvBA;EACE,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBD9OoB;EC+OpB,sBAAA;AAyBF;AAvBE;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,8BAAA;EACA,+BAAA;EACA,aAAA;EACA,8DACE;EAEF,SAAA;EACA,kBAAA;AAuBJ;AApBE;EACE,kBAAA;EACA,oCAAA;EACA,qCAAA;EACA,mBAAA;EACA,mBDjSmB;ECkSnB,kBAAA;EACA,gBAAA;AAsBJ;AAnBE;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,2BAAA;EACA,sBAAA;EACA,UAAA;EACA,oBAAA;EACA,iBAAA;AAqBJ;AAlBE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,oBAAA;EACA,sEAAA;EAKA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,oBAAA;AAgBJ;AAbE;EACE,kBAAA;EACA,oBAAA;EACA,oBAAA;EACA,UAAA;AAeJ;AAZE;EACE,WAAA;EACA,UAAA;EACA,mDAAA;EACA,oDAAA;EACA,QAAA;EACA,kFAAA;EAKA,iBAAA;EACA,yBAAA;AAUJ;AAPE;EACE,UAAA;EACA,YAAA;EACA,oDAAA;EACA,qDAAA;EACA,QAAA;EACA,4EAAA;EAKA,0BAAA;AAKJ;AAFE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,sBAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;EACA,oBAAA;EACA,iBAAA;AAIJ;AADE;EACE,kBAAA;EACA,cAAA;EACA,oBAAA;EACA,iBAAA;EACA,UAAA;AAGJ;AAAE;EACE,kBAAA;EACA,uCAAA;EACA,QAAA;EACA,kCAAA;EACA,YAAA;EACA,UAAA;EACA,4BAAA;EACA,oBAAA;EACA,iBAAA;AAEJ;AACE;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,YAAA;EACA,UAAA;EACA,oBAAA;EACA,iBAAA;AACJ;AAEE;EACE,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,4BAAA;EACA,kBAAA;AAAJ;AAGE;EACE,SAAA;EACA,cDpYkB;ECqYlB,eD3XO;EC4XP,iBAAA;EACA,gBAAA;EACA,uBAAA;AADJ;AAIE;EACE,gBAAA;EACA,cD7YkB;EC8YlB,eDvYO;ECwYP,gBAAA;EACA,gBAAA;EACA,gBAAA;AAFJ;AAKE;EACE,eAAA;EACA,cDzac;EC0ad,eDjZO;ECkZP,iBAAA;EACA,gBAAA;EACA,gBAAA;AAHJ;AAME;EACE,mBAAA;AAJJ;AAOE;EACE,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;EACA,cDzcmB;EC0cnB,eDtaO;ECuaP,iBDvaO;ECwaP,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,sGACE;EAIF,yBAAA;EACA,iBAAA;AATJ;AAWI;EACE,mBD1cgB;ACictB;AAYI;EACE,mBD7cgB;EC8chB,uBAAA;AAVN;AAaI;EACE,aAAA;EACA,8CAAA;AAXN;AAeE;EACE,mBDpdwB;ECqdxB,cDpdwB;ACuc5B;AAeI;EACE,mBDxdsB;AC2c5B;AAgBI;EACE,mBD1dsB;EC2dtB,uBAAA;AAdN;AAiBI;EACE,cDhesB;ACid5B;AAkBI;EACE,sBAAA;AAhBN;AAoBE;EACE,gDACE;AAnBN;AAuBE;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;EACA,oDACE;AAtBN;;AA2BA;EACE;IAAO,sBAAA;EAvBP;EAwBA;IAAO,sBAAA;EArBP;EAsBA;IAAO,mBAAA;EAnBP;AACF;AAqBA;EAEI;IACE,SAAA;EApBJ;EAuBE;IACE,uCAAA;EArBJ;EAwBE;IACE,YAAA;EAtBJ;EAyBE;IACE,gBAAA;EAvBJ;AACF;AA2BA;EAEI;IACE,iBAAA;EA1BJ;EA6BE;IACE,iBAAA;EA3BJ;EA8BE;IACE,aAAA;EA5BJ;EA+BE;IACE,aAAA;EA7BJ;AACF;AAiCA;EAEI;IACE,0BAAA;EAhCJ;EAmCE;IACE,aAAA;EAjCJ;EAoCE;IACE,aAAA;EAlCJ;AACF;AAyCA;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,mBDvjBoB;ECwjBpB,aAAA;EACA,sBAAA;EACA,gBAAA;AAvCF;AAyCE;EACE,OAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,mBDjkBkB;ECkkBlB,4BAAA;EACA,uBAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;AAvCJ;AA0CE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBD7lBkB;EC8lBlB,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAxCJ;AA2CE;EACE,WAAA;EACA,YAAA;EACA,cDtnBmB;AC6kBvB;AA4CE;EACE,gBAAA;EACA,cD5lBkB;EC6lBlB,6CAAA;EACA,eDtlBO;ECulBP,gBAAA;EACA,gBAAA;AA1CJ;AA6CE;EACE,gBAAA;EACA,cDznBc;EC0nBd,eDjmBO;ECkmBP,iBAAA;EACA,gBAAA;EACA,gBAAA;AA3CJ;;AA+CA;EACE,mBAAA;EACA,uBAAA;AA5CF;AA8CE;EACE,UAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,gFACE;AA7CN","sourcesContent":["// Paleta Primaria\r\n$toke-primario-morado: #5649B3;\r\n$toke-primario-acqua:  #00C4BB;\r\n\r\n// Paleta Complementaria\r\n$toke-royal:      #362893;\r\n$toke-purpura:    #9A7FF6;\r\n$toke-teal:       #00A6A6;\r\n$toke-mar:        #00EBDF;\r\n\r\n// Paleta Neutral\r\n$toke-gris:       #f2f2f2;\r\n$toke-granito:    #485974;\r\n$toke-teal-oscuro: #006680;\r\n\r\n// Estados interactivos — morado (copy button)\r\n$toke-morado-hover:   #dcd9f2;\r\n$toke-morado-active:  #bdaef9;\r\n$toke-morado-focus:   rgba(111, 98, 194, 0.18);\r\n\r\n// Estados interactivos — acqua (copy success)\r\n$toke-acqua-success-bg:     #ccf7f5;\r\n$toke-acqua-success-text:   #00807a;\r\n$toke-acqua-success-active: #b9f0ed;\r\n\r\n// Decorativo — banner desktop\r\n$toke-banner-glow-start: #22e6da;\r\n$toke-banner-glow-end:   #1cbab2;\r\n\r\n// Colores base\r\n$color-white:         #ffffff;\r\n$color-text-primary:  #101828;\r\n$color-text-heading:  #151d28;\r\n$color-border-subtle: #edf1f5;\r\n\r\n// Escala tipográfica\r\n$size-sm:  14px;\r\n$size-reg: 16px;\r\n$size-md:  18px;\r\n$size-lg:  20px;\r\n$size-xl:  24px;\r\n$size-2xl: 30px;\r\n\r\n// Tipografias\r\n$inter-font:  'Inter';\r\n$museo-font:  'Museo Sans Rounded';\r\n\r\n@font-face {\r\n    font-family: 'Inter';\r\n    src: url('../assets/fonts/Inter/Inter-Regular.ttf') format('truetype');\r\n    font-weight: 400;\r\n    font-style: normal;\r\n    font-display: swap;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Inter';\r\n    src: url('../assets/fonts/Inter/Inter-Semibold.ttf') format('truetype');\r\n    font-weight: 600;\r\n    font-style: normal;\r\n    font-display: swap;\r\n}\r\n\r\n@font-face {\r\n    font-family: 'Inter';\r\n    src: url('../assets/fonts/Inter/Inter-Bold.ttf') format('truetype');\r\n    font-weight: 700;\r\n    font-style: normal;\r\n    font-display: swap;\r\n}\r\n\r\n/* 100 - Thin */\r\n@font-face {\r\n    font-family: 'Museo Sans Rounded';\r\n    src: url('../assets/fonts/museo/MuseoSansRounded100.ttf') format('truetype');\r\n    font-weight: 100;\r\n    font-style: normal;\r\n    font-display: swap;\r\n}\r\n\r\n/* 300 - Light */\r\n@font-face {\r\n    font-family: 'Museo Sans Rounded';\r\n    src: url('../assets/fonts/museo/MuseoSansRounded300.ttf') format('truetype');\r\n    font-weight: 300;\r\n    font-style: normal;\r\n    font-display: swap;\r\n}\r\n\r\n/* 500 - Medium */\r\n@font-face {\r\n    font-family: 'Museo Sans Rounded';\r\n    src: url('../assets/fonts/museo/MuseoSansRounded500.ttf') format('truetype');\r\n    font-weight: 500;\r\n    font-style: normal;\r\n    font-display: swap;\r\n}\r\n\r\n/* 700 - Bold */\r\n@font-face {\r\n    font-family: 'Museo Sans Rounded';\r\n    src: url('../assets/fonts/museo/MuseoSansRounded700.ttf') format('truetype');\r\n    font-weight: 700;\r\n    font-style: normal;\r\n    font-display: swap;\r\n}\r\n\r\n/* 900 - Black */\r\n@font-face {\r\n    font-family: 'Museo Sans Rounded';\r\n    src: url('../assets/fonts/museo/MuseoSansRounded900.ttf') format('truetype');\r\n    font-weight: 900;\r\n    font-style: normal;\r\n    font-display: swap;\r\n}\r\n\r\n/* 1000 - Heavy / Ultra */\r\n@font-face {\r\n    font-family: 'Museo Sans Rounded';\r\n    src: url('../assets/fonts/museo/MuseoSansRounded1000.ttf') format('truetype');\r\n    font-weight: 1000;\r\n    font-style: normal;\r\n    font-display: swap;\r\n}","@import './variables';\r\n\r\n*,\r\n*::before,\r\n*::after {\r\n  box-sizing: border-box;\r\n}\r\n\r\nhtml,\r\nbody {\r\n  width: 100%;\r\n  height: 100%;\r\n  margin: 0;\r\n  padding: 0;\r\n  overflow: hidden;\r\n  overscroll-behavior: none;\r\n}\r\n\r\nbody {\r\n  font-family: $inter-font, sans-serif;\r\n  background: $color-white;\r\n  overflow-x: hidden;\r\n}\r\n\r\napp-deeplink {\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n.deeplink {\r\n  width: 100%;\r\n  height: 100%;\r\n  overflow: hidden;\r\n}\r\n\r\n\r\n// Mobile\r\n\r\n.deeplink-mobile {\r\n  width: 100%;\r\n  height: 100vh;\r\n  height: 100dvh;\r\n  background: $color-white;\r\n\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n\r\n  -webkit-overflow-scrolling: touch;\r\n  overscroll-behavior-y: contain;\r\n\r\n  position: relative;\r\n  padding-top: env(safe-area-inset-top);\r\n  padding-left: env(safe-area-inset-left);\r\n  padding-right: env(safe-area-inset-right);\r\n  padding-bottom: env(safe-area-inset-bottom);\r\n\r\n  &__hero {\r\n    position: sticky;\r\n    top: 0;\r\n    flex-shrink: 0;\r\n    z-index: 0;\r\n    isolation: isolate;\r\n    width: 100%;\r\n    height: clamp(320px, 44vh, 372px);\r\n    padding-top: env(safe-area-inset-top);\r\n    overflow: hidden;\r\n  }\r\n\r\n  &__hero-background {\r\n    position: absolute;\r\n    inset: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n    object-fit: cover;\r\n    object-position: center top;\r\n    pointer-events: none;\r\n    user-select: none;\r\n  }\r\n\r\n  &__hero-logo {\r\n    position: absolute;\r\n    left: 50%;\r\n    bottom: clamp(56px, 8.8vh, 74px);\r\n    transform: translateX(-50%);\r\n    width: clamp(170px, 51vw, 200px);\r\n    height: auto;\r\n    display: block;\r\n    z-index: 3;\r\n    pointer-events: none;\r\n    user-select: none;\r\n  }\r\n\r\n  &__hero-coin {\r\n    position: absolute;\r\n    top: 66px;\r\n    right: 36px;\r\n    width: 73px;\r\n    height: 73px;\r\n    display: block;\r\n    z-index: 2;\r\n    transform: rotate(-16deg);\r\n    pointer-events: none;\r\n    user-select: none;\r\n  }\r\n\r\n  &__badge {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 10px;\r\n\r\n    padding: clamp(6px, 1.5vw, 8px)\r\n             clamp(18px, 5vw, 24px);\r\n\r\n    position: absolute;\r\n    top: clamp(132px, 19.5vh, 164px);\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    z-index: 3;\r\n\r\n    background: $toke-primario-acqua;\r\n    border-radius: 24px 32px 0 24px;\r\n\r\n    font-family: $museo-font, sans-serif;\r\n    font-size: clamp($size-lg, 5.8vw, $size-xl);\r\n    line-height: 1.26;\r\n    font-weight: 700;\r\n    color: $color-white;\r\n  }\r\n\r\n  &__card {\r\n    position: relative;\r\n    flex: 1;\r\n    z-index: 2;\r\n    width: 100%;\r\n    margin-top: -32px;\r\n    background: $color-white;\r\n    border-radius: 32px 32px 0 0;\r\n    padding: 34px 16px 40px;\r\n    box-sizing: border-box;\r\n  }\r\n\r\n  &__title {\r\n    width: 100%;\r\n    margin: 0;\r\n    color: $color-text-heading;\r\n    font-size: $size-lg;\r\n    line-height: 24px;\r\n    font-weight: 800;\r\n    white-space: normal;\r\n  }\r\n\r\n  &__subtitle {\r\n    width: 100%;\r\n    margin: 8px 0 0;\r\n    color: $toke-granito;\r\n    font-size: $size-reg;\r\n    line-height: 20px;\r\n    font-weight: 400;\r\n  }\r\n\r\n  &__buttons {\r\n    width: 100%;\r\n    margin-top: 28px;\r\n    display: grid;\r\n    grid-template-columns: repeat(3, 1fr);\r\n    gap: 12px;\r\n  }\r\n\r\n  &__button {\r\n    width: 100%;\r\n    aspect-ratio: 114 / 96;\r\n    padding: 0;\r\n    border: 1px solid $color-border-subtle;\r\n    border-radius: 18px;\r\n    background: $color-white;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    box-shadow:\r\n      0 2px 4px rgba($color-text-primary, 0.04),\r\n      0 8px 18px rgba($color-text-primary, 0.08);\r\n    transition:\r\n      transform 0.15s ease,\r\n      box-shadow 0.2s ease;\r\n    overflow: hidden;\r\n    appearance: none;\r\n    -webkit-tap-highlight-color: transparent;\r\n    -webkit-user-select: none;\r\n    user-select: none;\r\n\r\n    &:active {\r\n      transform: scale(0.95);\r\n    }\r\n  }\r\n\r\n  &__button-logo {\r\n    display: block;\r\n    width: 79%;\r\n    height: auto;\r\n    object-fit: contain;\r\n    object-position: center;\r\n    flex-shrink: 0;\r\n    max-width: none;\r\n  }\r\n\r\n  &__secure {\r\n    margin-top: 28px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n  }\r\n\r\n  &__secure-icon {\r\n    display: block;\r\n    width: 16px;\r\n    height: 20px;\r\n    flex-shrink: 0;\r\n    object-fit: contain;\r\n  }\r\n\r\n  &__secure-text {\r\n    color: $toke-granito;\r\n    font-size: $size-sm;\r\n    line-height: 1.3;\r\n    font-weight: 500;\r\n  }\r\n}\r\n\r\n@media (max-width: 360px) {\r\n  .deeplink-mobile {\r\n    &__title {\r\n      font-size: 22px;\r\n    }\r\n\r\n    &__button {\r\n      height: 88px;\r\n    }\r\n\r\n    &__button-logo--toke,\r\n    &__button-logo--popular,\r\n    &__button-logo--qik {\r\n      width: 72px;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 290px) {\r\n  .deeplink-mobile {\r\n    &__buttons {\r\n      grid-template-columns: 1fr;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Desktop\r\n\r\n.deeplink-desktop {\r\n  width: 100%;\r\n  min-height: 100vh;\r\n  min-height: 100dvh;\r\n  padding: 24px;\r\n  background: $color-white;\r\n  box-sizing: border-box;\r\n\r\n  &__shell {\r\n    width: 100%;\r\n    max-width: 1400px;\r\n    margin: 0 auto;\r\n    min-height: calc(100vh - 48px);\r\n    min-height: calc(100dvh - 48px);\r\n    display: grid;\r\n    grid-template-columns:\r\n      minmax(0, 1.08fr)\r\n      minmax(420px, 0.92fr);\r\n    gap: 40px;\r\n    position: relative;\r\n  }\r\n\r\n  &__banner {\r\n    position: relative;\r\n    min-height: max(calc(100vh - 48px), 480px);\r\n    min-height: max(calc(100dvh - 48px), 480px);\r\n    border-radius: 30px;\r\n    background: $toke-primario-morado;\r\n    isolation: isolate;\r\n    overflow: hidden;\r\n  }\r\n\r\n  &__banner-background {\r\n    position: absolute;\r\n    inset: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    display: block;\r\n    object-fit: cover;\r\n    object-position: 68% center;\r\n    border-radius: inherit;\r\n    z-index: 0;\r\n    pointer-events: none;\r\n    user-select: none;\r\n  }\r\n\r\n  &__banner-glow {\r\n    position: absolute;\r\n    width: 460px;\r\n    height: 460px;\r\n    left: -150px;\r\n    bottom: -250px;\r\n    border-radius: 999px;\r\n    background: linear-gradient(\r\n      215.81deg,\r\n      $toke-banner-glow-start 59.63%,\r\n      $toke-banner-glow-end   64.38%\r\n    );\r\n    opacity: 0.5;\r\n    filter: blur(100px);\r\n    z-index: 1;\r\n    pointer-events: none;\r\n  }\r\n\r\n  &__banner-line {\r\n    position: absolute;\r\n    border-radius: 999px;\r\n    pointer-events: none;\r\n    z-index: 2;\r\n  }\r\n\r\n  &__banner-line--top {\r\n    width: 110%;\r\n    height: 4%;\r\n    left: calc(13% - 0.0968 * max(100vh - 48px, 480px));\r\n    left: calc(13% - 0.0968 * max(100dvh - 48px, 480px));\r\n    top: 12%;\r\n    background: linear-gradient(\r\n      87.14deg,\r\n      $toke-banner-glow-start               4.36%,\r\n      rgba($toke-banner-glow-start, 0)      79.64%\r\n    );\r\n    filter: blur(2px);\r\n    transform: rotate(134deg);\r\n  }\r\n\r\n  &__banner-line--middle {\r\n    width: 80%;\r\n    height: 2.5%;\r\n    right: calc(-8% - 0.0495 * max(100vh - 48px, 480px));\r\n    right: calc(-8% - 0.0495 * max(100dvh - 48px, 480px));\r\n    top: 65%;\r\n    background: linear-gradient(\r\n      150deg,\r\n      $toke-banner-glow-start               3.07%,\r\n      rgba($toke-primario-morado, 0)        28%\r\n    );\r\n    transform: rotate(-134deg);\r\n  }\r\n\r\n  &__banner-logo {\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    transform: translate(-50%, -50%);\r\n    width: min(65%, 602px);\r\n    height: auto;\r\n    z-index: 3;\r\n    display: block;\r\n    pointer-events: none;\r\n    user-select: none;\r\n  }\r\n\r\n  &__banner-decal {\r\n    position: absolute;\r\n    display: block;\r\n    pointer-events: none;\r\n    user-select: none;\r\n    z-index: 4;\r\n  }\r\n\r\n  &__banner-decal--bottom {\r\n    position: absolute;\r\n    left: calc((100% - 40px) * 0.54 - 55px);\r\n    top: calc(73%);\r\n    width: clamp(110px, 11.7vw, 169px);\r\n    height: auto;\r\n    z-index: 6;\r\n    transform: rotate(-21.72deg);\r\n    pointer-events: none;\r\n    user-select: none;\r\n  }\r\n\r\n  &__floating-decal {\r\n    position: absolute;\r\n    right: 0;\r\n    top: 2%;\r\n    width: 160px;\r\n    height: auto;\r\n    z-index: 6;\r\n    pointer-events: none;\r\n    user-select: none;\r\n  }\r\n\r\n  &__content {\r\n    position: relative;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 24px 40px 24px 24px;\r\n    text-align: center;\r\n  }\r\n\r\n  &__title {\r\n    margin: 0;\r\n    color: $color-text-primary;\r\n    font-size: $size-2xl;\r\n    line-height: 1.02;\r\n    font-weight: 800;\r\n    letter-spacing: -0.03em;\r\n  }\r\n\r\n  &__subtitle {\r\n    margin: 12px 0 0;\r\n    color: $color-text-primary;\r\n    font-size: $size-md;\r\n    line-height: 1.3;\r\n    font-weight: 700;\r\n    max-width: 420px;\r\n  }\r\n\r\n  &__helper-text {\r\n    margin: 6px 0 0;\r\n    color: $toke-granito;\r\n    font-size: $size-reg;\r\n    line-height: 1.35;\r\n    font-weight: 400;\r\n    max-width: 360px;\r\n  }\r\n\r\n  &__qr {\r\n    margin: 28px 0 16px;\r\n  }\r\n\r\n  &__copy {\r\n    position: relative;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 8px;\r\n    padding: 16px 24px;\r\n    border: none;\r\n    border-radius: 31px;\r\n    background: transparent;\r\n    color: $toke-primario-morado;\r\n    font-size: $size-reg;\r\n    line-height: $size-reg;\r\n    font-weight: 700;\r\n    cursor: pointer;\r\n    appearance: none;\r\n    overflow: hidden;\r\n    transition:\r\n      background-color 180ms ease,\r\n      color 180ms ease,\r\n      transform 120ms ease,\r\n      box-shadow 180ms ease;\r\n    -webkit-user-select: none;\r\n    user-select: none;\r\n\r\n    &:hover {\r\n      background: $toke-morado-hover;\r\n    }\r\n\r\n    &:active {\r\n      background: $toke-morado-active;\r\n      transform: scale(0.985);\r\n    }\r\n\r\n    &:focus-visible {\r\n      outline: none;\r\n      box-shadow: 0 0 0 2px $toke-morado-focus;\r\n    }\r\n  }\r\n\r\n  &__copy--success {\r\n    background: $toke-acqua-success-bg;\r\n    color: $toke-acqua-success-text;\r\n\r\n    &:hover {\r\n      background: $toke-acqua-success-bg;\r\n    }\r\n\r\n    &:active {\r\n      background: $toke-acqua-success-active;\r\n      transform: scale(0.985);\r\n    }\r\n\r\n    .deeplink-desktop__copy-label {\r\n      color: $toke-acqua-success-text;\r\n    }\r\n\r\n    .deeplink-desktop__copy-icon {\r\n      transform: scale(1.05);\r\n    }\r\n  }\r\n\r\n  &__copy-label {\r\n    transition:\r\n      color 180ms ease,\r\n      opacity 180ms ease;\r\n  }\r\n\r\n  &__copy-icon {\r\n    width: 24px;\r\n    height: 24px;\r\n    display: block;\r\n    flex-shrink: 0;\r\n    object-fit: contain;\r\n    transition:\r\n      transform 220ms ease,\r\n      opacity 180ms ease;\r\n  }\r\n}\r\n\r\n@keyframes deeplink-copy-success {\r\n  0%   { transform: scale(0.96); }\r\n  60%  { transform: scale(1.02); }\r\n  100% { transform: scale(1); }\r\n}\r\n\r\n@media (max-width: 1280px) {\r\n  .deeplink-desktop {\r\n    &__shell {\r\n      gap: 24px;\r\n    }\r\n\r\n    &__banner-decal--bottom {\r\n      left: calc((100% - 24px) * 0.54 - 55px);\r\n    }\r\n\r\n    &__floating-decal {\r\n      width: 140px;\r\n    }\r\n\r\n    &__content {\r\n      padding-right: 0;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 1023px) {\r\n  .deeplink-desktop {\r\n    &__banner {\r\n      min-height: 420px;\r\n    }\r\n\r\n    &__content {\r\n      padding: 24px 0 0;\r\n    }\r\n\r\n    &__floating-decal {\r\n      display: none;\r\n    }\r\n\r\n    &__banner-decal--bottom {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .deeplink-desktop {\r\n    &__shell {\r\n      grid-template-columns: 1fr;\r\n    }\r\n\r\n    &__banner {\r\n      display: none;\r\n    }\r\n\r\n    &__content {\r\n      padding: 24px;\r\n    }\r\n  }\r\n}\r\n\r\n\r\n// Error\r\n\r\n.deeplink-error {\r\n  width: 100%;\r\n  height: 100vh;\r\n  height: 100dvh;\r\n  background: $color-white;\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n\r\n  &__card {\r\n    flex: 1;\r\n    z-index: 2;\r\n    width: 100%;\r\n    margin-top: -32px;\r\n    background: $color-white;\r\n    border-radius: 32px 32px 0 0;\r\n    padding: 40px 24px 48px;\r\n    box-sizing: border-box;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    text-align: center;\r\n  }\r\n\r\n  &__icon-wrap {\r\n    width: 64px;\r\n    height: 64px;\r\n    border-radius: 50%;\r\n    background: $toke-morado-hover;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    flex-shrink: 0;\r\n  }\r\n\r\n  &__icon {\r\n    width: 28px;\r\n    height: 28px;\r\n    color: $toke-primario-morado;\r\n  }\r\n\r\n  &__title {\r\n    margin: 20px 0 0;\r\n    color: $color-text-heading;\r\n    font-family: $museo-font, sans-serif;\r\n    font-size: $size-xl;\r\n    font-weight: 700;\r\n    line-height: 1.2;\r\n  }\r\n\r\n  &__body {\r\n    margin: 10px 0 0;\r\n    color: $toke-granito;\r\n    font-size: $size-reg;\r\n    line-height: 1.55;\r\n    font-weight: 400;\r\n    max-width: 280px;\r\n  }\r\n}\r\n\r\n.deeplink-error--desktop {\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  .deeplink-error__card {\r\n    flex: none;\r\n    width: 100%;\r\n    max-width: 440px;\r\n    margin-top: 0;\r\n    border-radius: 24px;\r\n    padding: 56px 48px;\r\n    box-shadow:\r\n      0 2px 8px rgba($color-text-primary, 0.04),\r\n      0 16px 48px rgba($color-text-primary, 0.08);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
